import {
  Component,
  ViewChild,
  TemplateRef,
  AfterViewInit,
  ChangeDetectorRef,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import {
  MatRowDef,
  MatTableModule,
} from "@angular/material/table";
import { MatDialogModule, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { CommonModule, NgIf } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatSelectModule } from "@angular/material/select";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatOptionModule } from "@angular/material/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CompanyService } from "../../configuration/company/company.service.service";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatMenuModule } from "@angular/material/menu";
import { MatTabsModule } from "@angular/material/tabs";
import {
  NgSelectModule,
} from "@ng-select/ng-select";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { ICreateDocumentType } from "./interfaces/create-document-type.interface";
import DocumentTypeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/documents/document-type/document-type.entity";
import { ApplicationsAttributes } from "@albatrosdeveloper/ave-models-package";
import { IUpdateDocumentType } from "./interfaces/update-document-type.interface";
import { DocumentTypeService } from "./document-type.service";
import { Subject, ReplaySubject, take, takeUntil, Subscription } from "rxjs";
import { ApplicationService } from "../applications/applications.service";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";



@Component({
  selector: "app-document-type",
  templateUrl: "./document-type.component.html",
  styleUrls: ["./document-type.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    StatusFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})
export class DocumentTypeComponent implements AfterViewInit, OnDestroy {
  displayedColumns: string[] = ["code", "name", "status", "actions"];
  currentCreateDocumentType: ICreateDocumentType=
    this.initializeCreateDocumentType();
  currentUpdateDocumentType: DocumentTypeAttributes | undefined;

  dataSource: DocumentTypeAttributes[] = [];
  applicationList: any = [];
  selectedCompanyIds: string[] = [];

  searchQuery: string = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  protected _onDestroy = new Subject<void>();
  
    /** control for the selected application for multi-selection */
    public applicationMultiCtrl: FormControl<ApplicationsAttributes[]> = new FormControl<
      ApplicationsAttributes[]
    >([]);
  
    /** control for the MatSelect filter keyword multi-selection */
    public applicationMultiFilterCtrl: FormControl<string> =
      new FormControl<string>("");
  
    /** list of application filtered by search keyword */
    public filteredApplication: ReplaySubject<ApplicationsAttributes[]> =
      new ReplaySubject<ApplicationsAttributes[]>(1);
  
    /** local copy of filtered companies to help set the toggle all checkbox state */
    protected filteredApplicationCache: ApplicationsAttributes[] = [];
  
    /** flags to set the toggle all checkbox state */
    isIndeterminate = false;
    isChecked = false;
  

  //BUSCADOR
  searchSubscription: Subscription;

  // Status Filter Properties
  selectedStatuses: number[] = [1, 0]; // Default to show both active and inactive
    
  constructor(
    private readonly documentTypeService: DocumentTypeService,
    private readonly applicationService: ApplicationService,
    private readonly searchService: SearchService,
    private companyService: CompanyService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private fetchAllApplication(): void {
    this.applicationService.findToComboBox().subscribe({
      next: (res) => {
        this.applicationList = res;
        this.filteredApplication.next(this.applicationList);
              if (this.currentUpdateDocumentType?.applications) {
                this.filteredApplication.pipe(take(1)).subscribe((materials) => {
                  const selectedMaterials = materials.filter((material) =>
                    this.currentUpdateDocumentType.applications
                      .map((r) => r._id.toString())
                      .includes(material._id.toString())
                  );
                  this.applicationMultiCtrl.setValue(selectedMaterials);
                });
              }
              // listen for search field value changes
              this.applicationMultiFilterCtrl.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                  this.filterVisitMulti();
                  this.setToggleAllCheckboxStateVisit();
                });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener aplicaciones.","Cerrar",{ duration: 5000});
      },
    });
  }

  protected filterVisitMulti() {
    if (!this.applicationList) {
      return;
    }
    // get the search keyword
    let search = this.applicationMultiFilterCtrl.value;
    if (!search) {
      this.filteredApplicationCache = this.applicationList;
      this.filteredApplication.next(this.applicationList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredApplicationCache = this.applicationList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      return nameMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredApplication.next(this.filteredApplicationCache);
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredApplication
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.applicationMultiCtrl.patchValue(val);
        } else {
          this.applicationMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateVisit() {
    let filteredLength = 0;
    if (this.applicationMultiCtrl && this.applicationMultiCtrl.value) {
      this.filteredApplicationCache.forEach((el) => {
        if (this.applicationMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredApplicationCache.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredApplicationCache.length;
    }
  }


  private initializeCreateDocumentType(): ICreateDocumentType{
    return { code:"",name: "",applicationsIds: [] };  
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
    this.sort.direction ? this.sort.direction.toUpperCase() === "ASC" ? "ASC" : "DESC" : "ASC";


    this.documentTypeService
      .findAllWithCount({
        currentPage: pageIndex,
        limitPerPage: this.pageSize,
        search: this.searchQuery,
        sort: sortField,
        sortDirection: sortDirection,
      },
      { status: this.selectedStatuses.length ? this.selectedStatuses : null},
    )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof DocumentTypeAttributes {
    const validSortFields: (keyof DocumentTypeAttributes)[] = [
      "code",
      "name",
      "statusId",
    ];
    return validSortFields.includes(
      this.sort.active as keyof DocumentTypeAttributes
    )
      ? (this.sort.active as keyof DocumentTypeAttributes)
      : "code";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: DocumentTypeAttributes): string {
    return item._id.toString();
  }

  openCreateModal(): void {
    this.fetchAllApplication();
    this.currentCreateDocumentType= this.initializeCreateDocumentType();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose:true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createDocumentType());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(condition: DocumentTypeAttributes): void {
    this.fetchAllApplication();
    this.currentUpdateDocumentType= { ...condition };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose:true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateDocumentType(condition._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createDocumentType(): void {
    this.documentTypeService.create(this.currentCreateDocumentType).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
        this.dialogRefAdd.close()
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  updateDocumentType(id: string): void {
    if (this.currentUpdateDocumentType) {
      const updatedDocumentType: IUpdateDocumentType= {
        ...this.currentUpdateDocumentType,
      };

      this.documentTypeService.update(id, updatedDocumentType).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  onStatusChange(event: boolean, condition: DocumentTypeAttributes): void {
    const originalStatusId = condition.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedDocumentType = { statusId: updatedStatusId };

    this.documentTypeService
      .update(condition._id.toString(), updatedDocumentType)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          condition.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  openDeleteDialog(condition: DocumentTypeAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: condition, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(condition._id.toString()));
  }

  delete(id: string): void {
    this.documentTypeService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

//   onCompanySelectionChange(companyId: string): void {
//     if (this.currentUpdateDocumentType) {
//       this.currentUpdateDocumentType.company = this.companyList.find(
//         (company) => company._id.toString() === companyId
//       )!;
//     }
//   }

//   getSelectedCompanyCodes(selectedCompanyIds: string[]): number[] {
//     return selectedCompanyIds.map(
//       (id) => this.companyList.find((group) => group._id.toString() === id)?.id
//     );
//   }

  // Status Filter Methods
  applyStatusFilter(): void {
    this.paginator.pageIndex = 0; // Reset to first page when filtering
    this.findAllWithCount();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
